import { ballastItemLabel } from "../../../utils/ballastItemLabel";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AppInput from "../../../components/AppInput";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import SelectInput from "../../../components/SelectInput";
import { Button, Input,  Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import useDocumentUpload from "../../../hooks/useDocumentUpload";
import { ErrorToast } from "../../../widgets/AppToast";

function ViewBallastRecordBook() {
  const { ballast_id } = useParams();
  const [errors, set_errors] = useState({});
  const [code, set_code] = useState("");
  const [date, set_date] = useState("");
  const [signature, set_signature] = useState("");
  const [codeList, setCodeList] = useState([]);
  const [codeItemList, setCodeItemList] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [initialDocument, setInitialDocument] = useState([]);
  const { documentList, handleDocumentChange } = useDocumentUpload(initialDocument);

  const LIST_BALLAST_RECORD_CODE_API = () => {
    try {
      const FORM_DATA = new FormData();
      post(ApiURL.list_operation_codes_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const newRespones = res?.operation_codes?.map((item) => {
            return {
              value: item?.value,
              label: item?.label,
            };
          });
          LIST_BALLAST_RECORD_ITEM_API(newRespones?.[0]?.value);
          setCodeList(res?.operation_codes);
        }
      });
    } catch (error) {
      console.error("Error fetching Code list:", error);
    }
  };

  const LIST_BALLAST_RECORD_ITEM_API = (code_id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("code", code_id);
      post(ApiURL.list_operation_items_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const newRes = res?.operation_items?.map((item) => {
            return {
              value: item?.id,
              label: ballastItemLabel(item?.item_number),
              sub_code_name: item?.description,
            };
          });
          setCodeItemList(newRes);
        }
      });
    } catch (error) {
      console.error("Error fetching Code Item list:", error);
    }
  };

  const VIEW_BALLAST_RECORD_BOOK_APIS = () => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("ballasting_record_id", atob(ballast_id));
    post(ApiURL.view_ballasting_record_com, FORM_DATA).then((res) => {
      if (res?.status == true) {
        const oilRecordData = res?.record;
        set_code(oilRecordData?.operationCode);
        const subDetailValues = oilRecordData?.sub_detail_values || [];
        setSelectedItems(
          Array.isArray(subDetailValues)
            ? subDetailValues
            : typeof subDetailValues === "string" && subDetailValues.trim() !== ""
            ? JSON.parse(subDetailValues)
            : []
        );
        set_date(oilRecordData?.date);
        set_signature(oilRecordData?.ballasting_sign);
        setInitialDocument(oilRecordData?.files);
      } else {
        const errors = res?.errors || {};
        set_errors(errors);
      }
    });
  };

  useEffect(() => {
    LIST_BALLAST_RECORD_CODE_API();
    VIEW_BALLAST_RECORD_BOOK_APIS();
  }, []);

  const getDocUrl = (file) => {
    if (file.url) return file.url;
    if (file.originFileObj) return URL.createObjectURL(file.originFileObj);
    return null;
  };

  const handlePreviews = async (file) => {
    const url = getDocUrl(file);
    if (!url) {
      ErrorToast("Error mesaage", "No preview available for this file");
      return;
    }
    window.open(url, "_blank");
  };

  return (
    <>
      <div className="white-container">
        <br />
        <h3>Ballast Record book Information </h3>
        <br />
        <div className="row">
          <div className="col-6">
            <SelectInput
              disabled={true}
              label="Code"
              value={code}
              placeholder=" -- Selecte Code  -- "
              style={{ width: "100%" }}
              onChange={(value) => {
                set_code(value);
                setSelectedItems([]);
              }}
              options={codeList}
              errors={errors?.code}
            />
          </div>
          <div className="col-6">
            <AppInput
              disabled={true}
              type="date"
              label="Date"
              placeholder="Date"
              value={date}
              onChange={(e) => set_date(e.target.value)}
              errors={errors.date}
            />
          </div>
        </div>
        {code && (
          <div
            className="col-12"
            style={{
              lineHeight: "2",
              border: "1px solid #d9d9d9",
              borderRadius: "10px",
            }}
          >
            <strong className="form-label">Select Items:</strong>
            {codeItemList?.map((optionGroup, index) => (
              <div key={index} className="mb-3">
                <div className="row align-items-center mb-2">
                  <div className="col-6">
                    <div className="form-check">
                      <input
                        disabled
                        className="form-check-input"
                        type="checkbox"
                        value={optionGroup.label}
                        checked={selectedItems.some((item) => item.id === optionGroup.value)}
                        
                        id={`group-checkbox-${index}`}
                      />
                      <label className="form-check-label" htmlFor={`group-checkbox-${index}`}>
                        <strong>
                          {optionGroup.label} {optionGroup.sub_code_name}
                        </strong>
                      </label>
                    </div>
                  </div>

                  <div className="col-6">
                    {selectedItems.some((item) => item.id === optionGroup.value) && (
                      <Input
                        disabled
                        type="text"
                        required
                        className="form-control"
                        placeholder={optionGroup.label}
                        value={
                          selectedItems.find((item) => item.id === optionGroup.value)?.value || ""
                        }
                      />
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="row" style={{ paddingTop: "10px" }}>
          <div className="col-6">
            <AppInput
              disabled={true}
              label="Name of operation incharge"
              placeholder="Name of operation incharge"
              value={signature}
              onChange={(e) => set_signature(e.target.value)}
              errors={errors.signature}
            />
          </div>
          <div className="col-6">
            <div
              className="input-box"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "flex-start",
              }}
            >
              <label>Select File</label>
              <Upload
                accept=".pdf,.doc,.docx,.xls,.xlsx"
                multiple
                fileList={documentList}
                onChange={handleDocumentChange}
                onPreview={handlePreviews}
                beforeUpload={() => false}
                listType="picture"
                disabled
              >
                <Button
                  disabled
                  icon={<UploadOutlined />}
                  type="primary"
                  style={{
                    borderRadius: "50%",
                    padding: "10px",
                    width: "40px",
                    height: "40px",
                    marginLeft: "10px",
                  }}
                ></Button>
              </Upload>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewBallastRecordBook;
